<template>
  <div v-if="editMode">
    <div class="field-row">
      <div class="alert alert-info">
        <i class="fas fa-info-circle"></i>
        This is a display-only field that shows a title and description. No user input is collected.
      </div>
    </div>
  </div>
  <div v-else>
    <div class="vf-field-label">{{ field.fieldName }}</div>
  </div>
</template>

<script>
  export default {
    name: 'TitleDescriptionField',
    props: {
      field: {
        type: Object,
        required: true,
      },
      editMode: {
        type: Boolean,
        default: false
      },
    },
    mounted() {
      // Title/Description fields are never required since they don't collect input
      this.field.required = false;
    },
    data() {
      return {
        // Add your component data here
      };
    },
    methods: {
      // Add your component methods here
    },
  };
</script>

<style scoped>
  label {
    display: block;
    margin-bottom: 5px;
    font-weight: 500;
  }

  .alert {
    padding: 10px 15px;
    margin-bottom: 15px;
    border: 1px solid transparent;
    border-radius: 4px;
  }

  .alert-info {
    background-color: #d9edf7;
    border-color: #bce8f1;
    color: #31708f;
  }

  .alert i {
    margin-right: 5px;
  }
</style>
